import { render, staticRenderFns } from "./Expenses.vue?vue&type=template&id=a9a80f7c&scoped=true"
import script from "./Expenses.vue?vue&type=script&lang=js"
export * from "./Expenses.vue?vue&type=script&lang=js"
import style0 from "./Expenses.vue?vue&type=style&index=0&id=a9a80f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a80f7c",
  null
  
)

export default component.exports